module.exports = __webpack_public_path__ + "img/failed2.b6b5ffb6.svg";